<template>
  <div class="visitor py-5">
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    <b-container fluid>
      <h1 class="h2 text-gray-800 mb-4">Visitor List</h1>
      <b-table
        striped
        hover
        responsive
        :items="formattedVisitors"
        :per-page="perPage"
        :current-page="currentPage"
        id="visitor-list"
      >
        <template v-slot:cell(travel_overseas)="data">{{ data.value == 0 ? "No" : "Yes" }}</template>

        <template v-slot:cell(symptoms)="data">
          <ul>
            <li v-for="(x, key) in data.value" :key="key">{{ x }}</li>
          </ul>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="visitor-list"
      ></b-pagination>
    </b-container>
  </div>
</template>
<script>
const fb = require("../firebase");
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      visitors: [],
      perPage: 15,
      currentPage: 1,
      isLoading: false,
      fullPage: true
    };
  },
  components: {
    Loading
  },
  created() {
    this.isLoading = true;
    fb.db
      .collection("visitors")
      .orderBy("date", "desc")
      .get()
      .then(querySnapshot => {
        const documents = querySnapshot.docs.map(doc => doc.data());
        this.visitors = documents;
        this.isLoading = false;
      });
  },
  computed: {
    formattedVisitors() {
      return this.visitors.map(item => {
        return {
          date: item.date,
          name: item.name,
          company: item.organization,
          temperature: item.temperature,
          contact_no: item.contact_no,
          travel_overseas: item.travel_china,
          country: item.travel_china === 0 ? "None" : item.country,
          symptoms: item.symptoms
        };
      });
    }
  }
};
</script>